<template>
  <div class="banner">
    <div class="banner-wrapper">
      <div class="banner-img">
        <img src="../../../assets/images/banner/banner-qy.jpg" alt="" />
      </div>
    </div>
    <div class="companyBox">
      <div class="typeTitle">合作公司：</div>
      <div class="logoBox">
        <div
          class="logoItem"
          :style="{ color: flag == index ? '#2563eb' : 'inherit' }"
          v-for="(item, index) in companyTypeArr"
          :key="index"
          @click="clickCompany(index)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="searchBox">
      <div class="typeTitle">
        企业名称：<el-input
          v-model="input"
          style="width: 200px"
          placeholder="请输入企业名称"
          clearable
        ></el-input
        ><el-button
          style="margin-left: 10px"
          type="primary"
          @click="searchQuery"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="companyList">
      <div
        class="ulBox"
        v-for="(item, index) in companyAll"
        :key="index"
        v-if="item.arr.length > 0"
      >
        <div class="title">{{ item.title }}企业</div>
        <div class="info">
          <div v-for="(ele, idx) in item.arr" :key="idx" @click="toPath(ele)">
            {{ ele.companyName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  directives: {},
  data() {
    return {
      flag: 100,
      companies: [],
      input: "",
      companyTypeArr: [
        {
          value: "FINANCE",
          label: "金融",
        },
        {
          value: "LOGISTICS",
          label: "物流",
        },
        {
          value: "TRADE",
          label: "贸易",
        },
      ],
      companyAll: [],
    };
  },
  created() {
    this.getQyList({});
    this.getDicts();
  },
  mounted() {},
  methods: {
    clickCompany(idx) {
      if (this.flag == idx) {
        this.flag = 100;
      } else {
        this.flag = idx;
      }
      let obj = {
        category: this.flag == 100 ? undefined : this.companyTypeArr[idx].value,
        companyName: this.input,
      };
      this.getQyList(obj);
    },
    getQyList(obj) {
      let that = this;
      let values = { pageNum: 1, pageSize: 999, ...obj };
      axios
        .post(
          // `http://localhost:8091/product/partner-company/list2`,
          `http://121.40.212.122:8091/product/partner-company/list2`,
          values
        )
        .then((response) => {
          // 创建独立的数组副本
          that.companies = response.data.list;
          // console.log(response.data.list);
          let arrAll = [];
          that.companyTypeArr.map((item) => {
            let obj1 = {
              title: item.label,
              arr: [],
            };
            response.data.list.map((ele) => {
              if (item.value == ele.category) {
                obj1.arr.push(ele);
              }
            });
            arrAll.push(obj1);
          });
          this.companyAll = arrAll;
        })
        .catch(function (err) {
          console.log("error");
        });
    },
    searchQuery() {
      let obj = {
        category:
          this.flag == 100 ? undefined : this.companyTypeArr[this.flag].value,
        companyName: this.input,
      };
      this.getQyList(obj);
    },
    toPath(val){
      this.$router.push({
        name: "EnterpriseInfo", // 使用路由name（不是path！）
        params: {
          rowData:val, // 数据通过params传递
        },
      });
    },
    getDicts() {
      // let that = this;
      // axios
      //   .get(`http://121.40.212.122:8093/system/dict/data/type/company_type`)
      //   .then((response) => {
      //     // 创建独立的数组副本
      //     that.companyTypeArr = response.data.data;
      //   });
    },
  },
};
</script>

<style scoped>
.banner-img {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 180px;
  margin-bottom: 22px;
}
.banner-img img {
  width: 100%;
  height: 600px;
  backdrop-filter: color(100% 100%);
}
.companyBox {
  margin: 0 auto;
  width: 80%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.typeTitle {
  font-size: 20px;
  font-weight: bold;
  margin-right: 30px;
}
.logoBox {
  display: flex;
  justify-content: flex-start;
}
.logoItem {
  font-size: 20px;
  font-weight: 500;
  margin-right: 40px;
  cursor: pointer;
}
.searchBox {
  margin: 0 auto;
  margin-top: 20px;
  width: 80%;
}
.companyList {
  margin: 0 auto;
  margin-top: 20px;
  width: 80%;
  border: #ccc solid 1px;
  border-radius: 16px;
  min-height: 600px;
}
.ulBox {
  margin-top: 30px;
}
.title {
  text-align: center;
  font-size: 22px;
}
.info {
  display: flex;
  flex-wrap: wrap;
  /* 让子元素左对齐，剩余空间留在右边 */
  justify-content: flex-start;
  gap: 10px; /* 设置子元素之间的间距 */
  margin-top: 30px;
}

.info div {
  width: calc(25% - 10px); /* 每个子元素宽度占比，并减去间距 */
  box-sizing: border-box;
  background-color: #f0f0f0;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  background-color: #3f87bd;
  color: #fff;
}

.info div:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/children/Enterprise/EnterpriseView.vue